"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManualEntryLog = void 0;
var staticValues_1 = require("../staticValues");
var utils_1 = require("../utils/utils");
var convertNumberToEntries = function (number) {
    return String(number)
        .split('')
        .map(function (value) { return parseInt(value); });
};
var convertEntriesToNumber = function (entries) {
    return parseInt(entries.join(''));
};
var SegmentLog = /** @class */ (function () {
    function SegmentLog(_a) {
        var startingValue = _a.startingValue, segment = _a.segment, onUpdate = _a.onUpdate, onLimitHit = _a.onLimitHit;
        this.entries = [];
        this.value = startingValue;
        this.segment = segment;
        this.update = function () { return onUpdate(); };
        this.limitHit = function () { return onLimitHit(); };
    }
    /**
     * Adds a value to the to the log and keeps track of what the end value should be
     * @param keyName - Expected to be a keyboard key name like "1" or "a"
     */
    SegmentLog.prototype.add = function (keyName) {
        var _this = this;
        var number = parseInt(keyName);
        var isZero = number === 0;
        var isNumber = !isNaN(number);
        // Handles AM/PM
        if (this.segment === 'mode') {
            if (keyName.toLowerCase() === 'a') {
                this.value = 'AM';
                this.entries = [keyName];
            }
            if (keyName.toLowerCase() === 'p') {
                this.value = 'PM';
                this.entries = [keyName];
            }
            // Handles Hours and Minutes
        }
        else if (isNumber) {
            /*
                12:30 AM >> type 1 (hrs) >> [1] >> 01:30 AM
                12:30 AM >> type 1 > 2 (hrs) >> [1,2] >> 12:30 AM

                12:30 AM >> type 2 (hrs) >> [2] >> 02:30 AM
                12:30 AM >> type 2 > 1 (hrs) >> [1] >> 01:30 AM
                12:30 AM >> type 2 > 1 > 2 (hrs) >> [1,2] >> 12:30 AM

                12:30 AM >> type 0 (hrs) >> [1,2] >> 12:30 AM
            */
            var isGreaterThanMax = function (number) {
                if (_this.segment !== 'mode') {
                    return number > staticValues_1.maxAndMins[_this.segment].max;
                }
                return false;
            };
            var isFirst = this.entries.length === 0;
            var isSecond = this.entries.length === 1;
            var isThird = this.entries.length === 2;
            var isSecondZero = isZero && isSecond && this.entries[0] === 0;
            if (this.segment === 'hrs12') {
                if ((isFirst || isThird) && isZero) {
                    this.entries = [0];
                    this.value = 12;
                    this.update();
                    return;
                }
                else if (isSecondZero) {
                    this.entries = [0, 0];
                    this.value = 12;
                    this.limitHit();
                    this.update();
                    return;
                }
            }
            else if (this.segment === 'minutes') {
                if ((isFirst || isThird) && isZero) {
                    this.entries = [0];
                    this.value = 0;
                    this.update();
                    return;
                }
                else if (isSecondZero) {
                    this.entries = [0, 0];
                    this.value = 0;
                    this.limitHit();
                    this.update();
                    return;
                }
            }
            if (isZero && isSecond) {
                var isHrsSegment = this.segment === 'hrs12';
                var max = isHrsSegment ? 1 : 5;
                if (this.entries[0] > max) {
                    this.entries = [0];
                    this.value = isHrsSegment ? 12 : 0;
                }
                else {
                    this.entries.push(number);
                    this.value = convertEntriesToNumber(this.entries);
                    this.limitHit();
                }
                this.update();
                return;
            }
            var newEntries = __spreadArrays(this.entries, [number]);
            var newValue = convertEntriesToNumber(newEntries);
            if (isGreaterThanMax(newValue)) {
                this.value = number;
                this.entries = [number];
                if (isGreaterThanMax(number * 10)) {
                    this.limitHit();
                }
            }
            else {
                this.value = newValue;
                this.entries = newEntries;
                if (newEntries.length === 2 || isGreaterThanMax(number * 10)) {
                    this.limitHit();
                }
            }
        }
        this.update();
    };
    /**
     * Reset is needed for things like typing "1", then leaving, then coming back.
     *
     * The tracker should reset if they are returning.
     */
    SegmentLog.prototype.reset = function () {
        this.entries = [];
    };
    /**
     * Deletes the current value. Use this if the user presses delete or backspace.
     */
    SegmentLog.prototype.clear = function () {
        this.reset();
        this.value = null;
        this.update();
    };
    return SegmentLog;
}());
// Note: Due to this being a class, it does not need an interface
/**
 * Used for keeping track of Manual key strokes inside a time input
 */
var ManualEntryLog = /** @class */ (function () {
    function ManualEntryLog(_a) {
        var _this = this;
        var timeObject = _a.timeObject, _b = _a.onUpdate, onUpdate = _b === void 0 ? function () { } : _b, _c = _a.onLimitHit, onLimitHit = _c === void 0 ? function () { } : _c;
        var getFullValue12hr = function () {
            return [
                utils_1.toLeadingZero(_this.hrs12.value),
                ':',
                utils_1.toLeadingZero(_this.minutes.value),
                ' ',
                _this.mode.value || '--',
            ].join('');
        };
        var update = function () {
            _this.fullValue12hr = getFullValue12hr();
            if (onUpdate) {
                onUpdate(_this);
            }
        };
        var limitHit = function () {
            if (onLimitHit) {
                onLimitHit(_this);
            }
        };
        this.hrs12 = new SegmentLog({
            startingValue: timeObject.hrs12,
            segment: 'hrs12',
            onUpdate: update,
            onLimitHit: limitHit,
        });
        this.minutes = new SegmentLog({
            startingValue: timeObject.minutes,
            segment: 'minutes',
            onUpdate: update,
            onLimitHit: limitHit,
        });
        this.mode = new SegmentLog({
            startingValue: timeObject.mode,
            segment: 'mode',
            onUpdate: update,
            onLimitHit: limitHit,
        });
        this.fullValue12hr = getFullValue12hr();
    }
    /**
     * Deletes all of the values for all of the segments.
     */
    ManualEntryLog.prototype.clearAll = function () {
        this.hrs12.clear();
        this.minutes.clear();
        this.mode.clear();
    };
    return ManualEntryLog;
}());
exports.ManualEntryLog = ManualEntryLog;
